import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Accordion } from 'components/atoms/Accordion/Accordion';
import './FAQItem.scss';
export function FAQItem({ className, content }) {
	return (
		<div className={classnames(className)}>
			<Accordion
				className={className}
				content={content}
			/>
		</div>
	);
}

FAQItem.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
};

export default FAQItem;
